import { ReactNode, forwardRef } from 'react';
import {
  CheckboxLabelStyled,
  CheckboxInputStyled,
  CheckboxDecorStyled,
  CheckboxDecorFocusStyled,
} from './checkbox-input.style';
import { ReactComponent as Tick } from './tick.svg';

type Props = JSX.IntrinsicElements['input'] & {
  label?: ReactNode;
  inlineText?: string;
  description?: ReactNode;
  disabled?: boolean;
  inline?: boolean;
};

const CheckboxInput = forwardRef(
  (
    { label, disabled, description, inline, inlineText, ...inputProps }: Props,
    ref
  ) => {
    return (
      <CheckboxLabelStyled $disabled={disabled}>
        <CheckboxInputStyled
          ref={ref as any}
          type="checkbox"
          disabled={disabled}
          {...inputProps}
        />
        <CheckboxDecorStyled>
          <Tick />
        </CheckboxDecorStyled>
        <CheckboxDecorFocusStyled></CheckboxDecorFocusStyled>
        {label}
      </CheckboxLabelStyled>
    );
  }
);

export default CheckboxInput;
